import { render } from "./registered_cases.html?vue&type=template&id=007e51b0&external"
import script from "./registered_cases.js?vue&type=script&lang=js&external"
export * from "./registered_cases.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__